import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { cn } from '@/lib/utils';

/*
 * The one page header. Title + optional icon, one-line description, and an actions slot that
 * stays on the right on wide screens and wraps UNDER the title on phones (so buttons never get
 * squeezed into two-word columns). `back` renders a "← label" link above the title for detail
 * pages (slot settings, device settings).
 */
export default function PageHeader({ icon: Icon, title, description, actions, back, className, children }) {
  return (
    <div className={cn('mb-5 sm:mb-6', className)} data-testid="page-header">
      {back && (
        <Link
          to={back.to}
          className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors mb-2 tap"
        >
          <ArrowLeft className="h-4 w-4" />
          {back.label || 'Back'}
        </Link>
      )}
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div className="min-w-0">
          <h1 className="flex items-center gap-2.5 text-foreground">
            {Icon && (
              <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-primary/12 text-primary ring-1 ring-primary/20">
                <Icon className="h-[18px] w-[18px]" />
              </span>
            )}
            <span className="truncate">{title}</span>
          </h1>
          {description && (
            <p className="mt-1 text-sm text-muted-foreground text-pretty max-w-prose">{description}</p>
          )}
          {children}
        </div>
        {actions && (
          <div className="flex flex-wrap items-center gap-2 sm:justify-end sm:shrink-0">{actions}</div>
        )}
      </div>
    </div>
  );
}
